import {Serializers} from "../../interfaces/serializer";
import {Space} from "../../interfaces/space";

export const SPACES_STATE_NAME = 'spaces';

export interface SpacesState {
  spaces: Serializers<Space>;
  loading: boolean;
}
